// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Wn-z","badgeLink":"Xn-z","category":"Yn-z"};